<div class="member" *ngFor="let member of memberships | async">
  <app-membership-line-item [member]="member"></app-membership-line-item>
</div>
